/* Guides : carrousel mobile en CSS pur (scroll-snap) ; ce script ne fait QUE synchroniser les
   points de pagination avec la position de defilement. Il n'ajoute, ne retire et ne masque aucune
   carte : toutes sont dans le HTML (maillage interne). */
(function () {
  document.querySelectorAll('[data-guides-carousel]').forEach(function (track) {
    var wrap = track.parentElement;
    var dots = wrap && wrap.querySelector('[data-guides-dots]');
    if (!dots) return;
    var items = Array.prototype.slice.call(dots.children);
    var cards = Array.prototype.slice.call(track.children);
    function update() {
      if (!cards.length) return;
      var step = cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : track.clientWidth;
      var i = step > 0 ? Math.round(track.scrollLeft / step) : 0;
      i = Math.max(0, Math.min(items.length - 1, i));
      items.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
